import { create } from 'zustand';
import { Project, Marker } from '../types/vidmastro';

interface ProjectState {
    projects: Project[];
    currentProject: Project | null;
    markers: Marker[];
    loading: boolean;
    error: string | null;

    // Actions
    setProjects: (projects: Project[]) => void;
    setCurrentProject: (project: Project | null) => void;
    setMarkers: (markers: Marker[]) => void;
    addProject: (project: Project) => void;
    updateProject: (projectId: string, updates: Partial<Project>) => void;
    updateMarker: (markerId: string, updates: Partial<Marker>) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
    projects: [],
    currentProject: null,
    markers: [],
    loading: false,
    error: null,

    setProjects: (projects) => set({ projects }),
    setCurrentProject: (project) => set({ currentProject: project }),
    setMarkers: (markers) => set({ markers }),

    addProject: (project) => set((state) => ({
        projects: [project, ...state.projects]
    })),

    updateProject: (projectId, updates) => set((state) => ({
        projects: state.projects.map((p) =>
            p.id === projectId ? { ...p, ...updates } : p
        ),
        currentProject: state.currentProject?.id === projectId
            ? { ...state.currentProject, ...updates }
            : state.currentProject
    })),

    updateMarker: (markerId, updates) => set((state) => ({
        markers: state.markers.map((m) =>
            m.id === markerId ? { ...m, ...updates } : m
        )
    })),

    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error })
}));
